module.exports = __webpack_public_path__ + "img/sk-slavia-raha.790f426f.png";